// extracted by mini-css-extract-plugin
module.exports = {"container":"BannerWithDesc_container__Khiuq","bgImage":"BannerWithDesc_bgImage__D424S","title":"BannerWithDesc_title__g5nZQ","subtitle":"BannerWithDesc_subtitle__wZOlC"};